<template>
  <div class="fund-size-details">
    <RkTabs v-model="activeTab" :options="options" slider />
    <component :is="component" />
  </div>
</template>

<script>
import RkTabs from '@/components/common/RkTabs.vue'
import FundSizeDetailsNetWorth from '@/components/f10/etf/FundSizeDetailsNetWorth.vue'
import FundSizeDetailsHolder from '@/components/f10/etf/FundSizeDetailsHolder.vue'
const components = { worth: FundSizeDetailsNetWorth, holder: FundSizeDetailsHolder }
export default {
  components: { RkTabs },
  data() {
    return {
      activeTab: 'worth',
      options: Object.freeze([
        {
          label: '净资产变动',
          value: 'worth'
        },
        {
          label: '持有人变动',
          value: 'holder'
        }
      ])
    }
  },
  computed: {
    component() {
      return components[this.activeTab]
    }
  }
}
</script>
